import {getCheckoutSummary, getPaidPlanPercentDiscount, getTaxLabel} from '@wix/wix-events-commons-statics'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {classes} from './inner-summary.st.css'
import {InnerSummaryProps, SummaryItemProps} from './interfaces'

export const InnerSummary = ({invoice, selectedTicketsQuantity, withoutBreakdown}: InnerSummaryProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const {getFormattedMoney} = useCurrencyFormatter()
  const {subtotal, tax, addedFee, additionalFees, total, paidPlanDiscount} = getCheckoutSummary(
    invoice,
    getFormattedMoney,
  )
  const selectedTicketsLabel =
    selectedTicketsQuantity === 1
      ? t('seatings_selectedTicket')
      : t('seatings_selectedTickets', {count: selectedTicketsQuantity})

  return withoutBreakdown ? (
    <SummaryItem className={classes.total} label={selectedTicketsLabel} value={total} />
  ) : (
    <div className={classNames(classes.container, isMobile ? classes.mobileContainer : undefined)}>
      {subtotal ? (
        <Text tagName="p">
          <SummaryItem label={selectedTicketsLabel} value={subtotal} />
          <SummaryItem
            label={t('ticketsThankYou.paidPlan', {
              discount: getPaidPlanPercentDiscount(invoice),
            })}
            value={paidPlanDiscount}
          />
          <SummaryItem label={getTaxLabel(invoice)} value={tax} />
          {additionalFees.map((fee, index) => (
            <SummaryItem key={index} label={fee.name} value={fee.amount} />
          ))}
          <SummaryItem label={t('checkout_serviceFee')} value={addedFee} />
        </Text>
      ) : null}
      <SummaryItem className={classes.total} label={t('mobile.ticketsPicker.total')} value={total} />
    </div>
  )
}

const SummaryItem = ({label, value, className}: SummaryItemProps) =>
  value ? (
    <Text tagName="p" className={classNames(classes.summaryItem, className)} tab-index={0}>
      <Text className={classes.label}>{label}</Text>
      <Text className={classes.value}>{value}</Text>
    </Text>
  ) : null
